export const setupTime = (itemName: string) => {
  const now = new Date().getTime().toString()
  const setupTimeName = `setupTime${itemName}`
  localStorage.setItem(setupTimeName, now)
}
